module.exports = __webpack_public_path__ + "assets/img/free_30.55b957c8.png";